import React, {useEffect, useState} from "react";
import {CaptureDancingGif} from "../dancelestrations/gif";
import {TextScene} from "../../common/text";

export const MakeItADanceRainbow = ({isControl, round}) => {
    return <MakeItADance isControl={isControl} round={round} />;
}

// The scene's color is the room's (the show's light setting); the scene itself is a Make It A Dance round.
export const MakeItADanceRGB = ({isControl, round}) => {
    return <MakeItADance isControl={isControl} round={round} />;
}

export const MakeItADance = ({isControl, round}) => {
    const [assignment, setAssignment] = useState();

    const updateAssignment = () => {
        // Round 8 is the shared finale: everyone performs the boss row's
        // assignment together, off the big screen. Phones just point eyes up.
        const assignmentUrl = round === 8
            ? '/make-it-a-dance/get-self-assignment?' + new URLSearchParams({round, token: 'boss'})
            : '/make-it-a-dance/get-spotlight-round-assignment?' + new URLSearchParams({round});

        fetch(assignmentUrl, {credentials: 'include'})
            .then(response => response.json())
            .then(setAssignment)
    }

    useEffect(() => {
        updateAssignment();
    }, [round]);

    if(!isControl && round === 8) return <MakeItADanceFinalePlayer />;
    if(!assignment) return null;
    if(isControl && round === 8) return <MakeItADanceFinaleControl assignment={assignment} />;
    if(isControl) return <MakeItADanceControl assignment={assignment} />;
    return <MakeItADancePlayer assignment={assignment} />;
}

export const DanceText = ({isControl, text}) => {
    return <TextScene isControl={isControl} text={text} />;
}

// Fixed-position backdrop layer so the bg stays anchored to the viewport
// while content scrolls (background-attachment: fixed misbehaves on iOS).
const MakeItADancePlayerBackdrop = () => (
    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(/make-it-a-dance-assets/backdrop.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000',
        zIndex: -1,
        pointerEvents: 'none',
    }}/>
);

const taskTextStyle = (fontSize) => ({
    fontSize,
    fontFamily: '"Kanit", sans-serif',
    fontWeight: 900,
    fontStyle: 'italic',
    color: '#fff',
    letterSpacing: 1,
    display: 'inline-block',
    transform: 'rotate(-2deg)',
    textShadow: `${fontSize / 20}px ${fontSize / 20}px 0 #f32e00, ${fontSize / 12}px ${fontSize / 12}px 0 rgba(0,0,0,0.85)`,
});

const MakeItADanceControl = ({assignment}) => {
    return <div style={{
        height: '900px',
        width: '1600px',
        textAlign: 'center',
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(/make-it-a-dance-assets/backdrop-landscape.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000',
    }}>
        <div style={{margin: 40, textAlign: 'center'}}>
            <span style={taskTextStyle(80)}>“{assignment.value}”</span>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
            <div style={{fontSize: 80, fontWeight: 700, paddingTop: 10, textShadow: '0 2px 8px rgba(0,0,0,0.65), 2px 2px 0 rgba(0,0,0,0.65)'}}>{assignment.character.name}</div>
            <div style={{fontSize: 60, fontStyle: 'italic', opacity: 1, marginTop: 4, textShadow: '0 2px 6px rgba(0,0,0,0.65), 1px 1px 0 rgba(0,0,0,0.65)'}}>{assignment.character.nickname}</div>
            <img
                src={assignment.character.image_url}
                width={400}
                style={{
                    filter: 'drop-shadow(0 0 16px rgba(161,161,156,0.85)) drop-shadow(0 0 40px rgba(161,161,156,0.6))',
                }}
            />
        </div>
    </div>
}

// Shared finale, big screen: one giant assignment for the whole room,
// composited over the rainbow preset (transparent bg).
const MakeItADanceFinaleControl = ({assignment}) => {
    return <div style={{
        height: '900px',
        width: '1500px',
        textAlign: 'center',
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 30,
    }}>
        <div style={{
            fontSize: 90,
            fontWeight: 900,
            fontStyle: 'italic',
            letterSpacing: 14,
            textTransform: 'uppercase',
            color: '#fff',
            textShadow: '0 4px 0 rgba(0,0,0,0.85), 0 0 40px rgba(255,255,255,0.35)',
        }}>Everyone</div>
        <span style={taskTextStyle(110)}>“{assignment.value}”</span>
    </div>
}

const MakeItADanceFinalePlayer = () => {
    return <div className='evenly-distribute'>
        <MakeItADancePlayerBackdrop />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, textAlign: 'center'}}>
            <div style={{fontSize: 90}}>👀</div>
            <span style={taskTextStyle(40)}>Eyes on the screen!</span>
        </div>
    </div>
}

const MakeItADancePlayer = ({assignment}) => {
    return <div className='evenly-distribute'>
        <MakeItADancePlayerBackdrop />
        <div style={{margin: 20, textAlign: 'center'}}>
            <span style={taskTextStyle(46)}>“{assignment.value}”</span>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
            <div style={{fontSize: 40, fontWeight: 700, paddingTop: 10, textShadow: '0 2px 8px rgba(0,0,0,0.95), 2px 2px 0 rgba(0,0,0,0.95)'}}>{assignment.character.name}</div>
            <div style={{fontSize: 28, fontStyle: 'italic', opacity: 0.9, marginTop: 4, textShadow: '0 2px 6px rgba(0,0,0,0.95), 1px 1px 0 rgba(0,0,0,0.95)'}}>{assignment.character.nickname}</div>
            <img
                src={assignment.character.image_url}
                width={300}
                style={{
                    filter: 'drop-shadow(0 0 16px rgba(161,161,156,0.85)) drop-shadow(0 0 40px rgba(161,161,156,0.6))',
                }}
            />
        </div>
    </div>
}